import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { Link as RouterLink } from 'react-router-dom';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TradingButton from '../components/Trader/TradingButton';
import { useLocation } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';


export default function Footer() {
  const [value, setValue] = React.useState(0);
  const ref = React.useRef(null);
  const location = useLocation();
  const { pathname } = location;

  return (
    <Box sx={{ display: {md: 'none'},  pb: 7 }} ref={ref}>
      <CssBaseline />
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 20000  }} elevation={3}>
      {pathname === '/trade' ? 
         <TradingButton/>
        : 
        <BottomNavigation
        // 36492d
        // bce70c
        sx={{
          alignItems: 'center',
          padding: '10px',
          '& .MuiBottomNavigationAction-root': {
            padding: '6px 8px',
            minWidth: 'auto',
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.625rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }
          }
        }}
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction component={RouterLink} to="/" label="Home" icon={
             <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738083863/home_uktfab.png' sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar>  
          } />
          <BottomNavigationAction component={RouterLink} to="/start-trading" label="Digital Assets" icon={
            <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738083863/candle_l9uey7.png' sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
          </Avatar> } />

          <BottomNavigationAction component={RouterLink} to="/copy-plans" label="Crowd Funding" icon={
            <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068353/peer-to-peer_ekkqj5.png' sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar> 
            } />
          <BottomNavigationAction component={RouterLink} to="/package/Invest Funds" label="Invest" icon={
            <Avatar src='https://res.cloudinary.com/dqi4rtyvh/image/upload/v1739919729/profits_atawbu.png' sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar> 
          } />

          <BottomNavigationAction component={RouterLink} to="/assets" label="Portfolio" icon={
            <Avatar src='https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068347/wallet_1_vmr3li.png' sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar> 
          } />
          
          {/* <BottomNavigationAction label="Our Menu" icon={<MenuBookIcon />}/> */}
          
        </BottomNavigation>
        }
      </Paper>
    </Box>
  );
}
